import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { FinalCta } from "../components/common/FinalCta";
import { Reveal } from "../components/motion/Reveal";
import { AnimatedText } from "../components/motion/AnimatedText";
import { fileUrl } from "../context/SiteData";
import { API } from "../lib/api";


const BlogDetay = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API}/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setNotFound(true));
  }, [slug]);

  return (
    <>
      <section data-testid="blog-detail" className="pt-24 sm:pt-28">
        <div className="container-x max-w-3xl pb-16 sm:pb-20">
          <Reveal>
            <Link to="/blog" data-testid="blog-back-link" className="link-arrow mt-6 text-ink-500">
              <ArrowLeft size={15} />
              Tüm Yazılar
            </Link>
          </Reveal>
          {notFound && (
            <p className="mt-16 text-center text-sm text-ink-400">Yazı bulunamadı.</p>
          )}
          {post && (
            <>
              <Reveal delay={0.05}>
                <p className="label mt-10 flex items-center gap-3 text-ink-500">
                  <span className="inline-block h-px w-8 bg-ink-400" />
                  {new Date(post.created_at).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" })}
                </p>
              </Reveal>
              <h1 className="mt-4 text-3xl font-bold leading-tight tracking-tight text-ink-900 sm:text-5xl" data-testid="blog-detail-title">
                <AnimatedText text={post.title} delay={0.1} stagger={0.04} immediate />
              </h1>
              {post.cover_path && (
                <Reveal delay={0.15}>
                  <div className="mt-8 overflow-hidden">
                    <img src={fileUrl(post.cover_path)} alt={post.title} className="aspect-[16/9] w-full object-cover" />
                  </div>
                </Reveal>
              )}
              <Reveal delay={0.2}>
                <div className="mt-8 whitespace-pre-wrap text-base leading-relaxed text-ink-500 sm:text-lg" data-testid="blog-detail-content">
                  {post.content}
                </div>
              </Reveal>
            </>
          )}
        </div>
      </section>
      <FinalCta />
    </>
  );
};

export default BlogDetay;
